import React from 'react'

interface TextInfoProps{
  variant?: "row" | "column";
  title?:string;
  titleWeight?: string;
  description?:string | JSX.Element;
}
    
function TextInfo({variant="row",...props}:TextInfoProps) {
  return (
    <div className={`polymer_textinfo ${variant === "column" ? "polymer_textinfo__column" : ''}`}>
      {props.title && <p className={`polymer_textinfo__title ${variant === "column" ? "polymer_textinfo__title-full" : ''}`}  style={{fontSize:"1.125rem", fontWeight: props.titleWeight}}>{props.title}</p>}
      {props.description && <div className='polymer_textinfo__description'>{props.description}</div>}
    </div>
  )
}

export default TextInfo